/**
 * Types for Account Extensions components
 */

export type AccountExtensionType = 'callout' | 'sitelink' | 'structured_snippet';
export type AccountExtensionStatus = 'ENABLED' | 'PAUSED' | 'REMOVED';
export type AccountExtensionAction = 'enable' | 'pause' | 'remove';

export interface AccountExtension {
  asset_id: string;
  resource_name?: string;
  text: string;
  asset_type: AccountExtensionType;
  field_type: string;
  status: AccountExtensionStatus;
  google_ads_account_id?: string;
  // Sitelink-specific fields
  final_url?: string;
  description1?: string;
  description2?: string;
  // Structured snippet-specific fields
  header?: string;
  values?: string[];
}

export interface AccountExtensionCounts {
  callout: number;
  sitelink: number;
  structured_snippet: number;
}

// Asset type labels for display
export const ACCOUNT_EXTENSION_LABELS: Record<AccountExtensionType, string> = {
  callout: 'Callouts',
  sitelink: 'Sitelinks',
  structured_snippet: 'Structured Snippets',
};

// Asset type limits (max characters)
export const ACCOUNT_EXTENSION_LIMITS: Record<AccountExtensionType, number> = {
  callout: 25,
  sitelink: 25,
  structured_snippet: 25, // per value
};

// Sitelink description limits
export const SITELINK_DESCRIPTION_LIMIT = 35;

// Valid structured snippet headers from Google Ads API
export const STRUCTURED_SNIPPET_HEADERS = [
  'Amenities',
  'Brands',
  'Courses',
  'Degree programs',
  'Destinations',
  'Featured hotels',
  'Insurance coverage',
  'Models',
  'Neighborhoods',
  'Service catalog',
  'Shows',
  'Styles',
  'Types',
] as const;

export type StructuredSnippetHeader = typeof STRUCTURED_SNIPPET_HEADERS[number];

// Status badge configuration
export const STATUS_BADGE_CONFIG: Record<AccountExtensionStatus, { label: string; className: string }> = {
  ENABLED: { label: 'Enabled', className: 'bg-green-100 text-green-800' },
  PAUSED: { label: 'Paused', className: 'bg-yellow-100 text-yellow-800' },
  REMOVED: { label: 'Removed', className: 'bg-red-100 text-red-800' },
};
